<template>
    <!-- This assign tree is used for small screens when the active chat dropdown assign is not available -->
    <div id="sm-assign-tree" class="my-2">
        <!-- Search -->
        <b-form-input v-model="dropdownSearchQuery" :placeholder="$t('Search')" class="mb-1"></b-form-input>

        <!-- Unassigned -->
        <b-button
            :active="!assignee"
            :disabled="!assignee"
            variant="flat-light"
            @click="
                $emit('assign-chat', {
                    id: activeChat.lastConversation.id,
                    channelId: activeChat.channel.id,
                    identityId: activeChat.lastConversation.identityId,
                    tags: activeChat.tags,
                    userId: null,
                    teamId: null,
                    status: activeChat.lastConversation.status,
                })
            "
        >
            {{ $t("entities.conversation.Unassigned") }}
        </b-button>

        <!-- Users -->
        <hr v-if="usersTeamsTree.usersTree.length > 0" class="my-1" />

        <b-button
            v-for="user in usersTeamsTree.usersTree"
            :key="user.id"
            :active="user.id === activeChat.lastConversation.assignedUserId"
            :disabled="user.id === activeChat.lastConversation.assignedUserId"
            variant="flat-light"
            @click="
                $emit('assign-chat', {
                    id: activeChat.lastConversation.id,
                    channelId: activeChat.channel.id,
                    identityId: activeChat.lastConversation.identityId,
                    tags: activeChat.tags,
                    userId: user.id,
                    teamId: null,
                    status: activeChat.status,
                })
            "
        >
            <div :class="`badge-${resolveUserStatus(user.status)}`" class="badge user-status-badge"></div>
            {{ user.name }}
        </b-button>

        <!-- Teams and users -->
        <hr v-if="usersTeamsTree.teamsTree.length > 0" class="my-1" />

        <div v-for="team in usersTeamsTree.teamsTree" :key="`team-${team.id}`">
            <b-button
                :active="activeChat.lastConversation.assignedTeamId && team.id === (assignee && assignee.id)"
                :disabled="activeChat.lastConversation.assignedTeamId && team.id === (assignee && assignee.id)"
                variant="flat-light"
                @click="
                    $emit('assign-chat', {
                        id: activeChat.lastConversation.id,
                        channelId: activeChat.channel.id,
                        identityId: activeChat.lastConversation.identityId,
                        tags: activeChat.tags,
                        teamId: team.id,
                        status: activeChat.status,
                    })
                "
            >
                <font-awesome-icon :color="team.color" class="mr-1" icon="users" />
                {{ team.name }}
            </b-button>
            <b-button
                v-for="teamUser in team.users"
                :key="`teamuser-${teamUser.id}`"
                :active="!activeChat.assignedTeamId && teamUser.id === (assignee && assignee.id)"
                :disabled="!activeChat.assignedTeamId && teamUser.id === (assignee && assignee.id)"
                class="ml-3"
                variant="flat-light"
                @click="
                    $emit('assign-chat', {
                        id: activeChat.lastConversation.id,
                        channelId: activeChat.channel.id,
                        identityId: activeChat.lastConversation.identityId,
                        tags: activeChat.tags,
                        userId: teamUser.id,
                        teamId: team.id,
                        status: activeChat.status,
                    })
                "
            >
                <div :class="`badge-${resolveUserStatus(teamUser.status)}`" class="badge user-status-badge" />
                {{ teamUser.name }}
            </b-button>
        </div>
    </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { BButton, BFormInput, VBTooltip } from "bootstrap-vue";
import { resolveUserStatus, resolveTeamsUsersTree } from "@/utils/users";
import { getUserData } from "@/auth/getUserData";
import useUsers from "@/composables/useUsers";
import { ref } from "@vue/composition-api/dist/vue-composition-api";

export default {
    components: {
        BButton,
        BFormInput,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        teams: {
            type: Array,
            required: false,
        },
        activeChat: {
            type: Object,
            required: true,
        },
        isAssignChatPending: {
            type: Boolean,
            required: true,
        },
    },
    setup(props) {
        const { users } = useUsers();

        const assignee = computed(() => {
            if (props.activeChat.lastConversation.assignedUserId) {
                return users.value.find((user) => user.id === props.activeChat.lastConversation.assignedUserId);
            }

            if (props.activeChat.lastConversation.assignedTeamId) {
                return props.teams.find((team) => team.id === props.activeChat.lastConversation.assignedTeamId);
            }
        });

        const dropdownSearchQuery = ref("");
        return {
            assignee,
            resolveUserStatus,
            getUserData,
            usersTeamsTree: computed(() =>
                resolveTeamsUsersTree(props.teams, users.value, dropdownSearchQuery, props.activeChat.channel)
            ),
            dropdownSearchQuery,
        };
    },
};
</script>

<style lang="scss">
#sm-assign-tree {
    overflow: hidden;

    button {
        text-align: left;
        width: 100%;
    }

    .user-status-badge {
        height: 9px;
        width: 9px;
        padding: 0;
    }
    .user-status-badge:empty {
        display: inline-block;
    }
}

#modal-assign-to button.close {
    position: absolute;
    right: 0;
    top: 0;
    transform: none;
    margin: 0.5rem;
    cursor: pointer;
    z-index: 10;
}
</style>
